module.exports = __webpack_public_path__ + "static/shutterstock_1090445729-4b927f3febcf7db57ca40ff13cd4514e.jpg";